import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Briefcase,
  Workflow,
  FileSearch,
  MapPin,
  Share2,
  Globe,
  Inbox,
  CalendarClock,
  Kanban,
  Settings,
  Sparkles,
  Target,
} from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/", label: "Overview", icon: LayoutDashboard, key: "sidebar-nav-overview", pill: "1" },
  // { to: "/freelance", label: "Freelance Finder", icon: Briefcase, key: "sidebar-nav-freelance", pill: "1" },
  { to: "/leads", label: "Lead Engine", icon: Workflow, key: "sidebar-nav-leads", pill: "2" },
  { to: "/rfp", label: "RFP Intelligence", icon: FileSearch, key: "sidebar-nav-rfp", pill: "3" },
  { to: "/lead-finder", label: "Lead Finder", icon: MapPin, key: "sidebar-nav-maps", pill: "4" },
  // { to: "/social", label: "Social Automation", icon: Share2, key: "sidebar-nav-social", pill: "5" },
  { to: "/website", label: "Website Intel", icon: Globe, key: "sidebar-nav-website", pill: "5" },
  { to: "/analyzer", label: "Website Analyzer", icon: Target, key: "sidebar-nav-analyzer", pill: "6" },
  { to: "/crm", label: "Unified CRM", icon: Kanban, key: "sidebar-nav-crm", pill: "7" },
  { to: "/email", label: "Email Intel", icon: Inbox, key: "sidebar-nav-email", pill: "8" },
  { to: "/meetings", label: "Meetings Intel", icon: CalendarClock, key: "sidebar-nav-meetings", pill: "9" },

  { to: "/settings", label: "Settings", icon: Settings, key: "sidebar-nav-settings" },
];

export default function Sidebar() {
  return (
    <aside
      data-testid="app-sidebar"
      className="hidden lg:flex fixed left-0 top-0 h-screen w-[248px] flex-col border-r border-white/[0.06] bg-[#0a0a0d]/80 backdrop-blur-xl z-40"
    >
      {/* Brand */}
      <div className="px-6 pt-7 pb-6">
        <div className="flex items-center gap-2.5">
          <div className="relative">
            <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-indigo-500 to-cyan-400 grid place-items-center glow-indigo">
              <Sparkles className="h-4 w-4 text-white" strokeWidth={2.5} />
            </div>
            <div className="absolute inset-0 rounded-xl pulse-ring" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-[15px] font-bold tracking-tight text-white">
              Base2Brand
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/50">
              AI Sales OS
            </div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 space-y-0.5">
        {NAV.map(({ to, label, icon: Icon, key, pill }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={key}
            className={({ isActive }) =>
              cn(
                "group flex items-center gap-3 rounded-lg px-3 py-2 text-[13.5px] transition-all",
                isActive
                  ? "bg-white/[0.06] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]"
                  : "text-white/60 hover:text-white hover:bg-white/[0.03]"
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  className={cn(
                    "h-4 w-4 shrink-0 transition-colors",
                    isActive ? "text-indigo-300" : "text-white/40 group-hover:text-white/70"
                  )}
                  strokeWidth={2}
                />
                <span className="flex-1 truncate">{label}</span>
                {pill && (
                  <span className="font-mono text-[10px] px-1.5 py-0.5 rounded bg-white/[0.05] text-white/40 border border-white/[0.06]">
                    {pill}
                  </span>
                )}
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Footer status */}
      <div className="mx-3 mb-4 rounded-xl border border-white/[0.06] bg-white/[0.02] p-3">
        <div className="flex items-center gap-2">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" />
          </span>
          <span className="text-[11px] font-mono uppercase tracking-wider text-white/60">
            All systems nominal
          </span>
        </div>
        <div className="mt-2 flex items-center justify-between">
          <span className="text-[11px] text-white/40">7 workflows running</span>
          <span className="font-mono text-[10px] text-white/40">v1.0.0</span>
        </div>
      </div>
    </aside>
  );
}
